<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="orderInvoiceModal"
      persistent
      max-width="1000px"
    >
      <v-card>
        <form @submit.prevent="submitAfterValidate(false)">
          <v-card-title>
            <div class="headline">
              {{ $t('invoice.generateInvoiceTitle') }}
            </div>
          </v-card-title>
          <v-card-text class="pt-0 px-4">
            <div class="row" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #bbb; border-radius: 5px;">
              <div class="col-12 col-sm-6">
                <h5>{{ $t('invoice.customerLabel', { name: formData.customer_name }) }}</h5>
              </div>
              <div class="col-12 col-sm-6">
                <h5>{{ $t('invoice.phoneNumberLabel', { phone: formData.phone }) }}</h5>
              </div>

              <div
                v-if="formData.orders && formData.orders.length > 0"
                class="col-12 col-sm-12"
              >
                <h5>{{ $t('invoice.ordersLabel') }}</h5>
              </div>
              <div
                v-if="formData.orders && formData.orders.length > 0"
                class="col-12 col-sm-12"
              >
                <div class="d-flex flex-wrap">
                  <div
                    v-for="(order, index) in formData.orders"
                    :key="index"
                    class="mr-3 mb-2 d-flex align-center"
                  >
                    <h6 style="display: inline; margin: 0">#{{ order.the_order_id }}
                      <i
                      class="fa fa-remove ml-2"
                      style="font-size: 16px; color: red; cursor: pointer"
                      @click="removeOrder(index)"
                    ></i>
                    </h6>

                  </div>
                </div>
              </div>
              </div>
              <div class="row">

              <!-- <div class="col-12">
                <branch-select v-model="formData.branch_id_fk" />
              </div> -->

                  <div class="col-6 col-md-3">
                    <v-select
                      :label="$t('columns.warehouse')"
                      v-model="formData.warehouse_id"
                      :items="warehouses"
                      :error-messages="errors.collect('Warehouse')"
                      v-validate="'required'"
                      @input="isShipmentManual = false,isHandlingFeeManual = false,handleSelectWarehouse(formData.warehouse_id)"
                      data-vv-name="Warehouse"
                      item-text="text"
                      item-value="value"
                    />
                  </div>

                  <div style="display:none">
                    <v-select
                      :items="transportationTypes"
                      item-value="id"
                      item-text="name"
                      v-model="transportation_type"
                      @input="isShipmentManual = false,isHandlingFeeManual = false,getCustomerPriceList()"
                      data-vv-name="Transportation Type"
                      :label="$t('columns.transportationType') + '*'"
                    >
                    </v-select>
                  </div>

                  <div style="display:none">
                    <v-select
                      :label="$t('columns.orderType')"
                      v-model="formData.order_type_id"
                      :items="orderTypes"
                      @input="handleOrderTypeChange"
                      data-vv-name="order_type_id"
                      item-text="text"
                      item-value="value"
                    />
                  </div>

              <!-- Weight field - hidden but kept for calculation logic -->
              <!-- <div class="col-12 col-sm-3">
                <v-text-field
                  :label="$t('columns.weight')"
                  v-model="formData.weight"
                  :error-messages="errors.collect('Weight')"
                  @input="isShipmentManual = false,isHandlingFeeManual = false,calculateTotalAmount()"
                  v-validate="'required'"
                  data-vv-name="Weight"
                />
              </div> -->

              <!-- Volume field - hidden but kept for calculation logic -->
              <!-- <div class="col-12 col-sm-3">
                <v-text-field
                  :label="$t('columns.volume')"
                  v-model="formData.volume"
                  @input="isShipmentManual = false,isHandlingFeeManual = false,calculateTotalAmount()"
                />
              </div> -->

              <div class="col-12 col-md-3">
                <v-text-field
                  :label="$t('invoice.shipmentLabel')"
                  v-model.number="shipment"
                  @input="handleShipmentInput()"
                  :error-messages="errors.collect('Shipment')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Shipment"
                />
              </div>

              <div class="col-12 col-md-3">
                <v-text-field
                  :label="$t('columns.tax')"
                  v-model.number="formData.tax"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Tax')"
                  v-validate="'decimal:2'"
                  data-vv-name="Tax"
                />
              </div>

              <div class="col-12 col-md-3">
                <v-text-field
                  :label="$t('columns.discount')"
                  v-model.number="formData.discount"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Discount')"
                  v-validate="'decimal:2'"
                  data-vv-name="Discount"
                />
              </div>

              <!-- <div class="col-12 col-sm-3">
                <v-text-field
                  :label="$t('columns.deliveryPrice')"
                  v-model.number="formData.delivery_price"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Delivery price')"
                  v-validate="'decimal:2'"
                  data-vv-name="Delivery price"
                />
              </div> -->

              <!-- Delivery (IQD) input — commented out for now, kept for later use.
              <div class="col-12 col-sm-3">
                <v-text-field
                  :label="$t('orders.deliveryIqdLabel')"
                  v-model.number="formData.local_delivery"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Delivery IQD')"
                  v-validate="'decimal:2'"
                  data-vv-name="Delivery IQD"
                />
              </div>
              -->

              <div v-if="formData.is_ship_only == 1" class="col-12 col-md-3">
                <v-text-field
                  :label="$t('invoice.handlingFeeLabel')"
                  v-model.number="shiponly_handle_fee"
                  :error-messages="errors.collect('Handling Fee')"
                  @input="handleHandlingFeeInput"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Handling Fee"
                />
              </div>
              <div class="row"></div>

              <div class="col-12 col-sm-4">
                <v-text-field
                  :label="$t('invoice.totalPriceLabel')"
                  v-model.number="formData.total_price"
                  readonly
                  :error-messages="errors.collect('Total price')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Total price"
                  class="orange-text"
                />
              </div>

              <div class="col-12 col-sm-4">
                <v-text-field
                  :label="$t('invoice.totalIqdLabel')"
                  :value="Number(formData.total_iqd).toLocaleString('en-US')"
                  readonly
                  data-vv-name="Total IQD"
                  class="orange-text"
                />
              </div>

              <div class="col-12 col-sm-4">
                <v-text-field
                  :label="$t('columns.netPrice')"
                  v-model.number="formData.net_price"
                  readonly
                  :error-messages="errors.collect('Net price')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Net price"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  :label="$t('invoice.paidAmountLabel')"
                  v-model="formData.paid_amount"
                  @input="isPaidAmountManual = true"
                  :error-messages="errors.collect('Paid amount')"
                  v-validate="'decimal:2'"
                  data-vv-name="Paid amount"
                />
                <span
                  v-if="invoicePaymentBadge"
                  class="invoice-payment-badge"
                  :style="{ background: invoicePaymentBadge.bg, color: invoicePaymentBadge.color }"
                >{{ invoicePaymentBadge.label }}</span>
                <div
                  v-if="existingInvoiceRemaining > 0"
                  class="partial-remaining-note"
                >{{ $t('invoice.remainingAfterSelectedOrders', { usd: '$' + Number(existingInvoiceRemaining).toFixed(2), iqd: existingInvoiceRemainingIqd.toLocaleString() }) }}</div>
                <div
                  v-else-if="customerPartialRemainingUsd > 0"
                  class="partial-remaining-note"
                >{{ $t('invoice.remainingFromOtherPartialInvoices', { usd: '$' + Number(customerPartialRemainingUsd).toFixed(2), iqd: customerPartialRemainingIqd.toLocaleString() }) }}</div>
              </div>

              <div v-if="availableBalance > 0" class="col-12">
                <div class="available-balance-box">
                  <strong>{{ $t('recordInvoicePayment.availableTitle', { amount: '$' + Number(availableBalance).toFixed(2) }) }}</strong>
                  <ul>
                    <li v-for="(s, i) in availableBalanceSources" :key="i">{{ s.label }} ${{ Number(s.amount).toFixed(2) }} ({{ String(s.date).slice(0, 10) }})</li>
                    <li v-if="!availableBalanceSources.length">{{ $t('recordInvoicePayment.unknownSource') }}</li>
                  </ul>
                  <span class="balance-hint">{{ $t('recordInvoicePayment.balanceHint') }}</span>
                </div>
              </div>

              <div class="col-12 col-sm-6">
                <div class="balance-history-box">
                  <span v-if="balanceLoading">{{ $t('invoice.loadingText') }}</span>
                  <div v-else class="balance-equation">
                    <span class="balance-equation-item">
                      <span class="balance-equation-label">{{ $t('invoice.balanceLabel') }}</span>
                      <span :class="Number(customerBalance) < 0 ? 'balance-negative' : 'balance-positive'">$ {{ Number(customerBalance || 0).toFixed(2) }}</span>
                    </span>
                    <span class="balance-equation-op">{{ balanceEquationOperator }}</span>
                    <span class="balance-equation-item">
                      <span class="balance-equation-label">{{ $t('invoice.paidAmountLabel') }}</span>
                      <span>$ {{ Number(formData.paid_amount || 0).toFixed(2) }}</span>
                    </span>
                    <span class="balance-equation-op">=</span>
                    <span class="balance-equation-item">
                      <span class="balance-equation-label">{{ $t('invoice.remainingBalanceLabel') }}</span>
                      <span :class="remainingBalance < 0 ? 'balance-negative' : 'balance-positive'">$ {{ remainingBalance.toFixed(2) }}</span>
                    </span>
                  </div>
                </div>
                <div v-if="customerOutstandingInvoices.length > 0" class="balance-extra-line balance-extra-line--column">
                  <span class="balance-equation-label">{{ $t('invoice.shippingInvoiceNoLabel') }}</span>
                  <div class="selected-invoice-list">
                    <span
                      v-for="(inv, idx) in customerOutstandingInvoices"
                      :key="idx"
                      class="selected-invoice-chip"
                    >
                      <strong>{{ inv.invoice_number }}</strong>
                      <span
                        v-if="paymentStatusBadge(inv.payment_status, inv.edit_count)"
                        class="invoice-payment-badge"
                        :style="{ background: paymentStatusBadge(inv.payment_status, inv.edit_count).bg, color: paymentStatusBadge(inv.payment_status, inv.edit_count).color }"
                      >{{ paymentStatusBadge(inv.payment_status, inv.edit_count).label }}</span>
                      <span
                        v-if="inv.office_status === 'out_office'"
                        class="invoice-payment-badge out-office-badge"
                      >{{ $t('invoice.outOfficeButton') }}</span>
                    </span>
                  </div>
                </div>
                <div v-if="customerOutOfficeTotal > 0" class="balance-extra-line out-office-note">
                  {{ $t('invoice.customerOutOfficeTotalNote', { amount: '$' + Number(customerOutOfficeTotal).toFixed(2) }) }}
                </div>
              </div>

              <div class="col-12">
                <v-text-field
                  :label="$t('columns.note')"
                  v-model="formData.note"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="$emit('close')"
              style="height:auto"
              outline
            >{{ $t('common.cancel') }}</v-btn>
            <v-btn
              v-if="$_has_perm('save_order_invoice')"
              type="submit"
              style="height:auto"
              outline
              color="primary"
              :loading="submitting"
              :disabled="submitting || alreadyPaidLoading"
            >{{ $t('common.save') }}</v-btn>
            <v-btn
              v-if="$_has_perm('cash_view_order_invoice')"
              type="button"
              style="height:auto"
              outline
              color="primary"
              :loading="submitting"
              :disabled="submitting || alreadyPaidLoading"
              @click="submitAfterValidate(true)"
            >{{ $t('invoice.cashAndView') }}</v-btn>
            <v-btn
              v-if="$_has_perm('out_office_order_invoice')"
              type="button"
              style="height:auto"
              outline
              color="success"
              :loading="submitting"
              :disabled="submitting || alreadyPaidLoading || !isOutOfficeEligible"
              @click="submitPaidExternally('out_office')"
            >{{ $t('invoice.outOfficeButton') }}</v-btn>
            <v-btn
              v-if="$_has_perm('fib_order_invoice')"
              type="button"
              style="height:auto"
              outline
              color="success"
              :loading="submitting"
              :disabled="submitting || alreadyPaidLoading || lastTopupPaymentMethod !== 'fib'"
              @click="submitPaidExternally('fib')"
            >FIB</v-btn>
            <v-btn
              v-if="$_has_perm('qi_order_invoice')"
              type="button"
              style="height:auto"
              outline
              color="success"
              :loading="submitting"
              :disabled="submitting || alreadyPaidLoading || lastTopupPaymentMethod !== 'qi'"
              @click="submitPaidExternally('qi')"
            >QI Card</v-btn>
            <v-btn
              type="button"
              style="height:auto"
              outline
              color="warning"
              @click="previewInvoice()"
            >{{ $t('invoice.viewButton') }}</v-btn>
            <v-btn
              v-if="$_has_perm('attach_order_to_delivery')"
              type="button"
              style="height:auto"
              outline
              color="primary"
              :loading="submitting"
              :disabled="submitting"
              @click="submitAndAttachToDelivery()"
            >{{ $t('invoice.deliveryButton') }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <view-order-invoice
      :viewOrderInvoiceModal="viewOrderInvoiceModal"
      :invoiceData="invoiceData"
      :companyData="companyData"
      :exRate="exRate"
      @close="viewOrderInvoiceModal = false"
    />

    <!-- Shown instead of view-order-invoice when "Cash and view"/"View" settled several of the
         selected orders' own separate existing invoices rather than creating one new invoice —
         there's no single invoice to open, so every one actually paid gets printed together. -->
    <bulk-print-order-invoices
      :printData="bulkPrintDataResults"
      :companyData="companyData"
      :exRate="exRate"
      :closeModal="closeBulkPrintModal"
    />

    <!-- Shown by submitAndAttachToDelivery() ("Delivery" button) instead of either view above —
         a driver needs one consolidated document for the whole delivery request, not a
         per-invoice printout. -->
    <order-delivery-invoice
      :viewData="orderDeliveryViewData"
      :closeModal="closeOrderDeliveryModal"
      :companyData="companyData"
    />
  </v-layout>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import ViewOrderInvoice from './viewOrderInvoice.vue'
import BulkPrintOrderInvoices from './BulkPrintOrderInvoices.vue'
import OrderDeliveryInvoice from '../orderDelivery/orderDeliveryInvoice.vue'
import { roundUpIqd } from '../../mixins/helpers'

export default {
  components: {
    ViewOrderInvoice,
    BulkPrintOrderInvoices,
    OrderDeliveryInvoice
  },

  props: {
    orderInvoiceModal: {},
    formData: {},
    is_second_invoice: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // True from the click until POST api/order_invoice settles — disables every submit button
      // so a double-click / slow response can't send a second request (see store()'s order lock).
      submitting: false,
      warehouses: [],
      apiCustomerPrice: [],
      transportationTypes: [],
      orderTypes: [],
      shiponly_handle_fee: 0,
      shipment: 0,
      transportation_type: null,
      isHandlingFeeManual: false,
      isShipmentManual: false,
      isPaidAmountManual: false,
      viewOrderInvoiceModal: false,
      invoiceData: {},
      // Same safe pre-filled shape orderDeliveries.vue's own viewData uses — orderDeliveryInvoice.vue's
      // template reads viewData.resolved_customer.full_name etc. directly with no v-if guard, so an
      // empty {} here throws on mount, before the fetch in openOrderDeliveryView() even resolves.
      orderDeliveryViewData: {
        order: {
          customer: {}
        },
        resolved_customer: {},
        order_invoices: [],
        direct_orders: []
      },
      companyData: {},
      exRate: 1,
      lastTopupPaymentMethod: null,
      // Unused money on the customer's wallet (refund of a cancelled order, unused top-up) and
      // where it came from — see CustomerAvailableBalance on the backend.
      availableBalance: 0,
      availableBalanceSources: [],
      customerBalance: null,
      balanceLoading: false,
      // Total still uncollected across ALL of this customer's Out Office invoices — customer-wide,
      // unrelated to the order(s) currently being invoiced. Null until loaded / when unknown.
      customerOutOfficeTotal: null,
      // ALL of this customer's shipping invoices that still need attention (shape:
      // { invoice_number, office_status, payment_status, edit_count, remaining }) — fetched from
      // api/customer/{id}/outstanding-invoices, which only returns invoices tagged Out Office
      // (any payment status) or otherwise partial_paid. Deliberately NOT derived from the
      // currently selected orders (that was the previous, buggier approach: it only ever showed
      // invoice(s) tied to whichever orders happened to be checked, and hid a plain not_paid,
      // non-Out-Office invoice's siblings) — this list is the customer's real standing regardless
      // of what's selected right now.
      customerOutstandingInvoices: [],
      // Real, already-saved payment_status of the existing order_invoice attached to the
      // order (fetched from the backend) — null when no invoice has been created yet.
      // NOT derived from the live, unsaved "Paid amount" field, since that only previews
      // what a save would produce, not the order's actual current state.
      realPaymentStatus: null,
      // How many times this existing invoice has already been edited via this screen (see
      // OrderInvoiceController::updateExistingInvoice()) — null when no invoice exists yet.
      // Shown in the "edit this invoice?" confirm before submitting.
      existingInvoiceEditCount: null,
      // Total still owed (USD) across ALL of this customer's partial-paid shipping
      // invoices — a customer-wide figure, unrelated to the order(s) currently being
      // invoiced here. Fetched independently of the orders/no-orders branch above.
      customerPartialRemainingUsd: null,
      // Sum of paid_amount across every DISTINCT, non-canceled existing invoice linked to the
      // currently selected orders — received and fully paid ones included. formData.net_price
      // always includes every selected order's full price, so every dollar already paid on any of
      // them has to come off here too; skipping received+fully-paid invoices (as this used to)
      // made the default "Paid amount" re-ask for money already collected (SANDY JELO: $181.61
      // shown vs $124.85 really owed). Selected orders can each have their OWN separate
      // pre-existing invoice (most orders already get one auto-created at approval) — this is
      // computed across ALL of them via loadCombinedAlreadyPaidTotal(), not just the first
      // selected order, so the result doesn't depend on the order they were selected in.
      totalAlreadyPaid: 0,
      // True while loadCombinedAlreadyPaidTotal() is still fetching — the paying buttons stay
      // disabled until then, otherwise a quick click saves the full net as "Paid amount" before
      // what's already paid has been subtracted.
      alreadyPaidLoading: false,
      // Bumped on every loadCombinedAlreadyPaidTotal() call so a slower, older response (e.g.
      // before an order was removed) can't overwrite a newer one.
      alreadyPaidRequestId: 0,
      // Full invoice documents for bulk-print-order-invoices, populated only when "Cash and
      // view"/"View" settled multiple of the selection's own separate existing invoices instead
      // of creating one new one (see submitAfterValidate's success handler).
      bulkPrintDataResults: []
    }
  },

  computed: {
    invoicePaymentBadge() {
      return this.paymentStatusBadge(this.realPaymentStatus, this.existingInvoiceEditCount)
    },

    customerPartialRemainingIqd() {
      const raw = (Number(this.customerPartialRemainingUsd) || 0) * (Number(this.exRate) || 1)
      return roundUpIqd(raw)
    },

    // How much is left to collect across the selected orders' own existing invoices — see
    // totalAlreadyPaid. Naturally 0 when none of them have any outstanding paid
    // amount (brand-new orders, not_paid invoices that get discarded and replaced, or invoices
    // already fully paid and folded aside because they were received).
    existingInvoiceRemaining() {
      const net = Number(this.formData.net_price) || 0
      return Math.max(net - (Number(this.totalAlreadyPaid) || 0), 0)
    },

    existingInvoiceRemainingIqd() {
      const raw = this.existingInvoiceRemaining * (Number(this.exRate) || 1)
      return roundUpIqd(raw)
    },

    // A positive balance is credit the customer already has stored with us — paying now
    // draws down (subtracts from) that stored credit. A negative balance is a loan the
    // customer owes us — paying now pays it off (adds toward zero). Confirmed against
    // two real invoices: balance $170 + $30 paid -> $140 (subtract); balance -$9 + $9
    // paid -> $0 (add).
    balanceEquationOperator() {
      return (Number(this.customerBalance) || 0) >= 0 ? '-' : '+'
    },

    remainingBalance() {
      const balance = Number(this.customerBalance) || 0
      const paidAmount = Number(this.formData.paid_amount) || 0
      return balance >= 0 ? (balance - paidAmount) : (balance + paidAmount)
    },

    // Out Office only makes sense for an invoice that won't be fully paid yet once this submit
    // lands — once the projected paid amount reaches net_price there's nothing left to collect
    // at the office. formData.paid_amount only ever covers the NEW amount being collected now
    // (see totalAlreadyPaid's comment), so whatever was already paid on the selected
    // orders' own unreceived invoices has to be added back in before comparing against net_price.
    isOutOfficeEligible() {
      const projectedPaid = (Number(this.totalAlreadyPaid) || 0) + (Number(this.formData.paid_amount) || 0)
      return projectedPaid < (Number(this.formData.net_price) || 0)
    }
  },

  watch: {
    orderInvoiceModal(newValue) {
      if (newValue) {
        // Default weight and volume to 0 since fields are hidden
        if (!this.formData.weight) this.$set(this.formData, 'weight', 0)
        if (!this.formData.volume) this.$set(this.formData, 'volume', 0)
        this.availableBalance = 0
        this.availableBalanceSources = []
        // Use $set so these properties are reactive in Vue 2 (plain assignment
        // on a key that doesn't exist in the original object is non-reactive)
        this.$set(this.formData, 'tax', 0)
        this.$set(this.formData, 'discount', 0)
        this.$set(this.formData, 'total_price', 0)
        this.$set(this.formData, 'total_iqd', 0)
        this.$set(this.formData, 'net_price', 0)
        this.$set(this.formData, 'payment_method', null)
        this.$set(this.formData, 'paid_externally', false)
        this.shipment = 0
        this.isPaidAmountManual = false
        this.warehouses = []
        // Show orders sum immediately before async calls resolve
        this.calculateTotalAmount()
        this.getWarehouses()
        this.loadBalanceAndInvoiceStatus()
        this.loadCombinedAlreadyPaidTotal()
      }
    }
  },

  methods: {
    // Shared by invoicePaymentBadge (the selection's own first-order badge) and the per-invoice
    // chips in customerOutstandingInvoices — auto-generated invoices (created automatically at
    // order approval, never yet touched by staff via this screen) show grey instead of the
    // urgent red used for a genuinely unpaid invoice, matching orderInvoices.vue's list badge.
    paymentStatusBadge(status, editCount) {
      if (status === 'not_paid' && !Number(editCount)) {
        return { bg: '#E0E0E0', color: '#616161', label: this.$t('invoice.unpaidStatus') }
      }

      const map = {
        not_paid: { bg: '#F63049', color: '#FFFFFF', label: this.$t('invoice.unpaidStatus') },
        partial_paid: { bg: '#FFC85C', color: '#6B4C00', label: this.$t('invoice.partialPaidStatus') },
        paid: { bg: '#89D7B7', color: '#1A5940', label: this.$t('invoice.paidStatus') },
        cancel: { bg: '#FB8C00', color: '#FFFFFF', label: this.$t('invoice.cancelStatus') }
      }

      return map[status] || null
    },

    // Sums paid_amount across every DISTINCT, non-canceled existing invoice linked to the
    // currently selected orders — see totalAlreadyPaid's own comment for why this has to check
    // ALL selected orders (each can have its own separate pre-existing invoice) rather than just
    // the first one, which previously made the result depend on selection order.
    loadCombinedAlreadyPaidTotal() {
      this.totalAlreadyPaid = 0
      const requestId = ++this.alreadyPaidRequestId

      const orders = this.formData.orders || []
      if (orders.length === 0) {
        this.alreadyPaidLoading = false
        return
      }

      this.alreadyPaidLoading = true
      const token = localStorage.getItem('access_token')

      Promise.all(
        orders.map((o) =>
          axios
            .get(`api/show_order_detail/${o.order_id}`, { headers: { Authorization: 'Bearer ' + token } })
            .then((response) => (response.data.data || [])[0] || null)
            .catch(() => null)
        )
      ).then((details) => {
        if (requestId !== this.alreadyPaidRequestId) return

        const seenInvoiceIds = new Set()
        let total = 0

        details.forEach((detail) => {
          if (!detail || !detail.order_invoice_id_fk) return
          // Dedupe: several selected orders can already share the SAME invoice (e.g. a
          // batch-approved combo) — its paid_amount must only be counted once.
          if (seenInvoiceIds.has(detail.order_invoice_id_fk)) return
          seenInvoiceIds.add(detail.order_invoice_id_fk)

          // A canceled invoice's amount was already voided/refunded, so it isn't money the
          // customer has paid toward these orders any more.
          if (detail.payment_status === 'cancel') return

          // Received or not, fully paid or not: this money was already collected for an order
          // whose full price is inside formData.net_price, so it always comes off. The backend
          // only ever records up to what's still owed and now rejects anything above it (see
          // OrderInvoiceController::rejectOverpayment()).
          total += Number(detail.invoice_paid_amount) || 0
        })

        this.totalAlreadyPaid = total
        this.alreadyPaidLoading = false
        // Re-run now that we know how much is already paid across the selection's existing
        // invoices — calculateTotalAmount() defaults "Paid amount" using this total (see its
        // own comment), and this data wasn't available yet the first time it ran synchronously
        // when the modal opened.
        this.calculateTotalAmount()
      })
    },

    loadBalanceAndInvoiceStatus() {
      this.realPaymentStatus = null
      this.existingInvoiceEditCount = null
      this.customerBalance = null

      // Customer-wide remaining balance across ALL of this customer's partial-paid
      // shipping invoices — deliberately independent of the order-selection branching
      // below, since it's unrelated to whichever order(s) are currently being invoiced.
      this.loadCustomerPartialRemaining()
      this.loadCustomerOutstandingInvoices()

      const firstOrder = (this.formData.orders || [])[0]

      // Orders selected: pull real credit + real invoice payment_status (if one already
      // exists for this order) from the same order-detail endpoint the rest of the app
      // already uses — this reflects what's actually saved, not the unsaved form values.
      // Only used for the informational badge/edit-count below — with multiple orders
      // selected, each possibly on its own separate invoice, "Paid amount"'s own default
      // is driven by loadCombinedAlreadyPaidTotal() instead, which checks all of them.
      if (firstOrder && firstOrder.order_id) {
        this.balanceLoading = true
        const token = localStorage.getItem('access_token')
        axios
          .get(`api/show_order_detail/${firstOrder.order_id}`, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then((response) => {
            const detail = (response.data.data || [])[0] || {}
            this.customerBalance = detail.credit
            this.realPaymentStatus = detail.payment_status || null
            this.existingInvoiceEditCount = detail.invoice_edit_count != null ? Number(detail.invoice_edit_count) : null
          })
          .catch(() => {
            this.customerBalance = null
            this.realPaymentStatus = null
            this.existingInvoiceEditCount = null
          })
          .finally(() => {
            this.balanceLoading = false
          })
        return
      }

      // No orders (customer picked directly from the dropdown) — there's no existing
      // invoice to check, only the current balance.
      if (!this.formData.customer_id) return

      this.balanceLoading = true
      const token = localStorage.getItem('access_token')
      axios
        .get(`api/customer/${this.formData.customer_id}/credit-summary`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.customerBalance = response.data.data.credit
        })
        .catch(() => {
          this.customerBalance = null
        })
        .finally(() => {
          this.balanceLoading = false
        })
    },

    loadCustomerPartialRemaining() {
      this.customerPartialRemainingUsd = null
      this.lastTopupPaymentMethod = null
      this.customerOutOfficeTotal = null
      if (!this.formData.customer_id) return

      const token = localStorage.getItem('access_token')

      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => {
          this.exRate = res.data ? res.data.ex_rate || 1 : 1
          // calculateTotalAmount() already ran synchronously against the default exRate (1)
          // when the modal opened (see the orderInvoiceModal watcher) — re-run now that the
          // real rate is in, same reasoning as loadCombinedAlreadyPaidTotal() re-running it.
          this.calculateTotalAmount()
        })
        .catch(() => {})

      axios
        .get(`api/customer/${this.formData.customer_id}/credit-summary`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.customerPartialRemainingUsd = response.data.data.partial_remaining
          this.lastTopupPaymentMethod = response.data.data.last_topup_payment_method || null
          this.customerOutOfficeTotal = response.data.data.out_office_total
          this.availableBalance = Number(response.data.data.available_balance) || 0
          this.availableBalanceSources = response.data.data.available_balance_sources || []
        })
        .catch(() => {
          this.customerPartialRemainingUsd = null
          this.lastTopupPaymentMethod = null
          this.customerOutOfficeTotal = null
        })
    },

    // ALL of this customer's shipping invoices that still need attention — every Out Office
    // invoice (any payment status) plus every other partial_paid one (see
    // OrderInvoiceController::outstandingForCustomer()). A plain not_paid, non-Out-Office
    // invoice is excluded by the backend query itself, not filtered here. Customer-wide, same as
    // loadCustomerPartialRemaining() — independent of whichever order(s) are currently selected.
    loadCustomerOutstandingInvoices() {
      this.customerOutstandingInvoices = []
      if (!this.formData.customer_id) return

      const token = localStorage.getItem('access_token')

      axios
        .get(`api/customer/${this.formData.customer_id}/outstanding-invoices`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.customerOutstandingInvoices = response.data.data || []
        })
        .catch(() => {
          this.customerOutstandingInvoices = []
        })
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        }).finally(() => {
          if (this.formData.warehouse_id) {
            this.handleSelectWarehouse(this.formData.warehouse_id)
          }
        })
    },

    getCustomerPriceList() {
      var token = localStorage.getItem('access_token')
      let params = {
        customer_id_fk: this.formData.customer_id,
        warehouse_id_fk: this.formData.warehouse_id,
        order_type_id_fk: this.formData.order_type_id
      }
      axios
        .post('api/subscription-pricing/customer-price', params, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          let data = response.data
          this.apiCustomerPrice = data.data
          this.formData.shiponly_handling_fee = this.transportation_type === 1 ? data.data.shiponly_handling_fee_air : data.data.shiponly_handling_fee_sea
          this.formData.shipment = this.transportation_type === 1 ? data.data.item_price_air : this.transportation_type === 2 ? data.data.item_price_sea : data.data.item_price_land
          this.isHandlingFeeManual = false
          this.isShipmentManual = false
        })
        .catch((errors) => { })
        .finally(() => {
          this.calculateTotalAmount()
        })
    },

    getOrderTypes() {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/subscription-pricing/get-order-types/` + this.formData.warehouse_id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          this.orderTypes = [] // Clear existing order types
          result.forEach((r) => {
            this.orderTypes.push({
              text: r.type_name,
              value: r.order_type_id,
              type_price_air: r.type_price_air,
              type_price_sea: r.type_price_sea,
              type_price_land: r.type_price_land
            })
          })
          // Auto-select first order type if none is set
          if (this.orderTypes.length > 0 && !this.formData.order_type_id) {
            this.formData.order_type_id = this.orderTypes[0].value
          }
          this.getCustomerPriceList()
        })
    },

    handleOrderTypeChange() {
      this.isShipmentManual = false
      this.isHandlingFeeManual = false
      this.getCustomerPriceList()
    },

    handleSelectWarehouse(id) {
      this.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
      }
      // Use the order's transportation_type if set, otherwise auto-select the first available
      this.transportation_type = this.formData.transportation_type ||
        (this.transportationTypes && this.transportationTypes.length > 0 ? this.transportationTypes[0].id : null)

      this.getOrderTypes()
    },

    removeOrder(index) {
      this.formData.orders.splice(index, 1)
      this.calculateTotalAmount()
      this.loadCombinedAlreadyPaidTotal()
    },

    handleHandlingFeeInput() {
      this.isHandlingFeeManual = true
      this.calculateTotalAmount()
    },

    handleShipmentInput() {
      this.isShipmentManual = true
      this.calculateTotalAmount()
    },

    getOrdersSum() {
      return (this.formData.orders || []).reduce((sum, o) => sum + (Number(o.total_amount) || 0), 0)
    },

    calculateTotalAmount() {
      let tax = Number(this.formData.tax) || 0
      let deliveryPrice = Number(this.formData.delivery_price) || 0
      let discount = Number(this.formData.discount) || 0

      if (this.formData.is_ship_only == 1 && !this.isHandlingFeeManual) {
        this.shiponly_handle_fee = parseFloat((Math.max(this.formData.volume, this.formData.weight) * this.formData.shiponly_handling_fee || 0).toFixed(2))
      } else if (this.formData.is_ship_only != 1) {
        this.shiponly_handle_fee = 0
      }

      if (!this.isShipmentManual) {
        this.shipment = parseFloat((Math.max(this.formData.volume, this.formData.weight) * this.formData.shipment || 0).toFixed(2))
      }

      const ordersSum = this.getOrdersSum()
      // Must be the SAME rate used by existingInvoiceRemainingIqd/customerPartialRemainingIqd
      // below (both driven by this.exRate, fetched live from api/currency-rate/latest in
      // loadCustomerPartialRemaining()) and by the backend's own save-time conversion
      // (OrderInvoiceController reads the latest CurrencyRate row fresh on every store/update).
      // localStorage.user_data.ex_rate is only refreshed on specific page loads and can go
      // stale mid-session, which previously made "Total IQD" disagree with both of those.
      const _exRate = Number(this.exRate) || 1
      // Each order's total_amount may already include its local_delivery (converted to USD).
      // Subtract what is baked in, then add back the current field value so the user can
      // enter or adjust delivery at invoice time without double-counting.
      const bakedLocalDeliveryUsd = (this.formData.orders || [])
        .reduce((sum, o) => sum + (Number(o.local_delivery) || 0) / _exRate, 0)
      const currentLocalDeliveryUsd = (Number(this.formData.local_delivery) || 0) / _exRate
      const gross = ordersSum - bakedLocalDeliveryUsd + currentLocalDeliveryUsd + Number(this.shipment) + tax + deliveryPrice + Number(this.shiponly_handle_fee)
      const net = gross - discount
      this.formData.handling_fee = this.shiponly_handle_fee
      // total_price = gross (before discount); backend computes net_price = total_price - discount
      this.formData.total_price = gross.toFixed(2)
      this.formData.total_iqd = Math.round(gross * _exRate)
      this.formData.net_price = net.toFixed(2)
      if (!this.isPaidAmountManual) {
        // Default "Paid amount" to what's still owed across the selection (recomputed net minus
        // whatever's already paid on their own unreceived invoices — see
        // totalAlreadyPaid), not the full net — the backend now records this field as a
        // new incremental payment whenever an existing invoice is involved (see
        // OrderInvoiceController::updateExistingInvoice() and store()'s multi-invoice combine
        // branch), so staff should see "how much to collect now", not the total ignoring what's
        // already been paid. Naturally reduces to the plain full net for a brand-new invoice with
        // nothing paid yet, or one being replaced/folded aside (both leave the total at 0).
        const defaultPaidAmount = Math.max(net - (Number(this.totalAlreadyPaid) || 0), 0)
        this.$set(this.formData, 'paid_amount', defaultPaidAmount.toFixed(2))
      }
    },

    getCompanyData(token) {
      axios
        .get('api/company_info', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData = response.data.data
        })
    },

    openShippingInvoiceView(id, extraFlags = { is_save_and_view: true }) {
      const token = localStorage.getItem('access_token')
      this.getCompanyData(token)

      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => {
          this.exRate = res.data ? res.data.ex_rate || 1 : 1
        })
        .catch(() => {})

      axios
        .get(`api/order_invoice/${id}`, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((res) => {
          this.viewOrderInvoiceModal = true
          // Default (called right after this component's own "Save and view" submit) flags
          // the print log as "Save and view". submitAndAttachToDelivery() instead passes
          // { is_delivery: true } so the print log distinguishes a delivery-attach print,
          // same way is_save_and_view distinguishes View from Save-and-view.
          this.invoiceData = Object.assign({}, res.data, extraFlags)
        })
    },

    // Used instead of openShippingInvoiceView() when the submit paid down MULTIPLE of the
    // selection's own separate existing invoices rather than creating one new one — there's no
    // single invoice id to open, so every one actually paid gets fetched and printed together
    // via the same bulk-print mechanism orderInvoices.vue's "Print" button already uses.
    viewMultipleInvoices(ids) {
      const token = localStorage.getItem('access_token')
      this.getCompanyData(token)

      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => {
          this.exRate = res.data ? res.data.ex_rate || 1 : 1
        })
        .catch(() => {})

      axios
        .get('api/order_invoice/bulk-print', {
          params: { ids },
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.bulkPrintDataResults = response.data.data
          // bulk_print_order_invoices_modal is BulkPrintOrderInvoices.vue's own hardcoded
          // element id (not a prop) — safe to reuse here since it and orderInvoices.vue's own
          // instance of this component are never mounted on the same page (different routes).
          $('#bulk_print_order_invoices_modal').modal({ backdrop: 'static' })
        })
    },

    closeBulkPrintModal(modal) {
      $('#' + modal).modal('toggle')
    },

    // Shown after the "Delivery" button attaches invoice(s) to a delivery request — one
    // consolidated document listing every attached invoice/order, same view orderDeliveries.vue's
    // own "View" action opens. orderDeliveryModal is orderDeliveryInvoice.vue's own hardcoded
    // element id (not a prop) — safe to reuse here since it and orderDeliveries.vue's own instance
    // of this component are never mounted on the same page (different routes).
    openOrderDeliveryView(orderDeliveryId) {
      const token = localStorage.getItem('access_token')
      this.getCompanyData(token)

      axios
        .get(`api/order-delivery/${orderDeliveryId}`, { headers: { Authorization: 'Bearer ' + token } })
        .then((res) => {
          this.orderDeliveryViewData = res.data
          $('#orderDeliveryModal').modal({ backdrop: 'static' })
        })
    },

    closeOrderDeliveryModal(modal) {
      $('#' + modal).modal('toggle')
    },

    previewInvoice() {
      this.$validator.validateAll().then((res) => {
        if (!res) return
        const token = localStorage.getItem('access_token')
        this.getCompanyData(token)
        axios
          .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
          .then((r) => { this.exRate = r.data ? r.data.ex_rate || 1 : 1 })
          .catch(() => {})

        // "View" previews the invoice exactly as it's actually saved right now — never the
        // form's own "Paid amount" field, which only ever holds a NOT-YET-SUBMITTED amount and
        // must never leak into what's supposed to be a read of real, persisted state:
        //  - Existing invoice (realPaymentStatus known): "Paid amount" auto-fills to exactly
        //    enough to settle what's left owed (see totalAlreadyPaid's own comment),
        //    which would make an already-partial-paid invoice preview as "fully paid" despite
        //    nothing having been submitted yet.
        //  - No existing invoice at all: "Paid amount" still defaults to the FULL net price
        //    (calculateTotalAmount()'s own default, assuming a same-day cash sale) even though
        //    literally nothing has been generated or collected yet — previewing that as "Paid"
        //    would be wrong for the exact same reason.
        // Either way, Paid/Remaining/status come straight from what's actually on file —
        // totalAlreadyPaid/existingInvoiceRemaining/realPaymentStatus when an invoice
        // exists, or the plain unpaid full-price default when it doesn't.
        const previewHasExistingInvoice = !!this.realPaymentStatus
        const previewNetPrice = Number(this.formData.net_price) || 0
        const previewPaidAmount = previewHasExistingInvoice ? (Number(this.totalAlreadyPaid) || 0) : 0
        const previewRemainingAmount = previewHasExistingInvoice ? this.existingInvoiceRemaining : previewNetPrice
        const previewPaymentStatus = previewHasExistingInvoice ? this.realPaymentStatus : 'not_paid'

        this.invoiceData = {
          // Unique per preview so each "View" print gets its own print-log row instead of
          // colliding with (and overwriting the customer name on) every other preview ever
          // printed — the log lookup in PrintLogController::store matches on invoice_number.
          invoice_number: 'PREVIEW-' + Date.now(),
          created_at: new Date().toLocaleDateString(),
          is_preview: true,
          customer: {
            full_name: this.formData.customer_name,
            phone_number: this.formData.phone,
          },
          orders: (this.formData.orders || []).map((o) => ({
            theOrderID: o.the_order_id,
            product_name: o.product_name || '',
            size: o.size || '',
            item_price: Number(o.total_amount) || 0,
            internal_shipping_handling: 0,
            total_amount: Number(o.total_amount) || 0,
            local_delivery: Number(o.local_delivery) || 0,
            quantity: 1,
          })),
          second_orders: [],
          shipment: this.shipment,
          tax: this.formData.tax,
          discount: this.formData.discount,
          handling_fee: this.formData.handling_fee,
          delivery_price: this.formData.delivery_price,
          local_delivery: this.formData.local_delivery,
          total_price: this.formData.total_price,
          net_price: this.formData.net_price,
          note: this.formData.note,
          paid_amount: previewPaidAmount,
          remaining_amount: previewRemainingAmount,
          payment_status: previewPaymentStatus,
          // Prefer the real, already-saved edit_count for an existing invoice (so an untouched
          // auto-generated not_paid one still shows grey, not red) — matches store()'s own
          // edit_count:1 for any manually-generated invoice only when there's genuinely no
          // existing invoice to reflect.
          edit_count: this.existingInvoiceEditCount != null ? this.existingInvoiceEditCount : 1,
        }
        this.$emit('view-clicked')
        this.viewOrderInvoiceModal = true
      })
    },

    // For orders already paid via a FIB/QI/Office top-up or payment (which already
    // credited the customer's balance and applied it to these orders) — skips moving
    // customer.credit again, avoiding double-crediting money the customer already has.
    // Uses whatever is currently in "Paid amount" (auto-filled to net_price, or the
    // user's own edit) so the resulting invoice reflects paid/partial_paid/not_paid
    // based on the real amount, instead of always forcing it to fully paid.
    submitPaidExternally(method) {
      if (this.submitting) {
        return
      }
      this.formData.payment_method = method
      this.formData.paid_externally = true
      this.submitAfterValidate(true)
    },

    // Shared by submitAfterValidate() and submitAndAttachToDelivery() — the actual
    // POST api/order_invoice call, resolving to the created/updated invoice id(s) so each
    // caller can decide what to do next (open a preview vs. attach to a delivery request).
    submitOrderInvoice() {
      // Plain "Save" / "Cash and view" — not routed through submitPaidExternally, so
      // payment_method isn't set yet; label it explicitly rather than leaving it null.
      if (!this.formData.paid_externally) {
        this.formData.payment_method = 'cash'
      }

      const token = localStorage.getItem('access_token')
      this.formData.is_second_invoice = this.is_second_invoice
      this.formData.shipment = this.shipment
      // Not used by the save itself — only stored in invoice_generate_audits (see
      // OrderInvoiceController::finishGenerateAudit()) so a later cash/ledger mismatch can be
      // traced back to what this screen was actually showing when staff pressed the button.
      const auditContext = {
        page: this.$route ? this.$route.path : null,
        suggested_paid_amount: Number(Math.max((Number(this.formData.net_price) || 0) - (Number(this.totalAlreadyPaid) || 0), 0).toFixed(2)),
        paid_amount_edited: this.isPaidAmountManual,
        already_paid_shown: Number(this.totalAlreadyPaid) || 0,
        already_paid_loaded: !this.alreadyPaidLoading,
        customer_balance_shown: Number(this.customerBalance) || 0,
        ex_rate: Number(this.exRate) || null
      }
      return axios
        .post('api/order_invoice', Object.assign({}, this.formData, { audit_context: auditContext }), {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          const invoiceId = response.data && response.data.order_invoice_id
          const invoiceIds = (response.data && response.data.invoice_ids) || []
          return { invoiceId, invoiceIds }
        })
    },

    submitAfterValidate(openView) {
      // alreadyPaidLoading: also covers pressing Enter inside the form, which the disabled
      // Save button alone doesn't block.
      if (this.submitting || this.alreadyPaidLoading) {
        return
      }
      this.submitting = true

      this.$validator.validateAll().then((res) => {
        if (!res) {
          this.submitting = false
          return
        }

        this.submitOrderInvoice()
          .then(({ invoiceId, invoiceIds }) => {
            this.$emit('invoice-created')
            this.$emit('close')
            if (openView) {
              if (invoiceIds.length > 1) {
                // Multiple of the selection's own separate existing invoices got paid down in
                // place instead of one new one being created (see OrderInvoiceController::
                // payDownInvoicesIndividually()) — there's no single invoice to open, so print
                // every one actually touched together instead.
                this.$nextTick(() => {
                  this.viewMultipleInvoices(invoiceIds)
                })
              } else if (invoiceId) {
                this.$nextTick(() => {
                  this.openShippingInvoiceView(invoiceId)
                })
              } else if (invoiceIds.length === 1) {
                this.$nextTick(() => {
                  this.openShippingInvoiceView(invoiceIds[0])
                })
              } else {
                swal(this.$t('common.warning'), this.$t('invoice.invoiceSavedNoPreview'), 'warning')
              }
            } else {
              swal({
                title: this.$t('common.done'),
                text: this.$t('invoice.invoiceGeneratedSuccessfully'),
                icon: 'success',
                timer: 750,
                buttons: false
              })
            }
          })
          .catch((err) => {
            const msg = (err.response && err.response.data && err.response.data.message)
              ? err.response.data.message
              : this.$t('invoice.requestFailed')
            swal(this.$t('common.warning'), msg, 'error')
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },

    // "Delivery" button — generates the invoice exactly like Save does, then attaches it
    // to the customer's pending order-delivery request (see OrderDeliveryController::
    // attachInvoices()). Not atomic with the invoice creation, but safe to retry: a second
    // click re-submits the same orders (hitting store()'s existing-invoice update branch,
    // not a duplicate create) and re-attaching an already-attached invoice is a no-op.
    submitAndAttachToDelivery() {
      if (this.submitting) {
        return
      }
      this.submitting = true

      this.$validator.validateAll().then((res) => {
        if (!res) {
          this.submitting = false
          return
        }

        // The "Delivery" button always generates a NOT-PAID invoice — payment for a delivery
        // request is collected/reconciled separately (see DeliveryInvoice/attachOrders()'s
        // deliberately-unpaid invoices), regardless of whatever "Paid amount" the form's own
        // default (or a manual edit) currently has.
        this.formData.paid_amount = 0
        // Tells store()/payDownInvoicesIndividually() this submission is delivery-attach only —
        // when the selection spans multiple existing invoices, partial/fully-paid ones must be
        // left completely untouched (never paid down or merged) and only not-paid ones get
        // attached (splitting one if just some of its orders are selected).
        this.formData.for_delivery = true

        const attachToDelivery = (attachIds) => {
          if (attachIds.length === 0) {
            this.$emit('close')
            swal(this.$t('common.warning'), this.$t('invoice.invoiceSavedNoAttach'), 'warning')
            return
          }

          const token = localStorage.getItem('access_token')
          axios
            .post('api/order-delivery/attach-invoices', {
              customer_id: this.formData.customer_id,
              order_invoice_ids: attachIds
            }, { headers: { Authorization: 'Bearer ' + token } })
            .then((response) => {
              this.$emit('close')
              // Show the order delivery request's own consolidated view instead of the
              // individual shipping invoice(s) — a driver needs one single document listing
              // every attached invoice and order, not a separate printout per invoice (which
              // also didn't render at all once more than one invoice was attached).
              const openInvoiceViews = () => {
                this.$nextTick(() => {
                  this.openOrderDeliveryView(response.data.order_delivery_id)
                })
              }

              // attach-invoices silently skips any invoice already tied to a delivery request
              // (this one or a different, possibly already-completed one) rather than moving it —
              // surface that here so staff know it wasn't actually (re)attached, instead of
              // assuming it now belongs to this customer's current delivery request.
              const skipped = response.data.skipped_invoice_numbers || []
              if (skipped.length > 0) {
                swal(
                  this.$t('columns.note'),
                  this.$t('invoice.alreadyAttachedNote', { list: skipped.join(', ') }),
                  'info'
                ).then(openInvoiceViews)
              } else {
                openInvoiceViews()
              }
            })
            .catch((err) => {
              this.$emit('close')
              const msg = (err.response && err.response.data && err.response.data.message)
                ? err.response.data.message
                : this.$t('invoice.attachFailed')
              swal(this.$t('common.warning'), this.$t('invoice.invoiceCreatedCouldNotAttach', { msg }), 'warning')
            })
        }

        this.submitOrderInvoice()
          .then(({ invoiceId, invoiceIds }) => {
            this.$emit('invoice-created')
            const attachIds = invoiceIds.length > 0 ? invoiceIds : (invoiceId ? [invoiceId] : [])
            attachToDelivery(attachIds)
          })
          .catch((err) => {
            // The selected order(s) already sit on a fully reconciled (received) invoice and
            // this submission adds no new charge — store() refuses to create a same-amount
            // duplicate but tells us which invoice already covers them (existing_invoice_id,
            // see OrderInvoiceController::store()). Attach that existing invoice instead of
            // treating this as a hard failure.
            const existingInvoiceId = err.response && err.response.data && err.response.data.existing_invoice_id
            if (existingInvoiceId) {
              this.$emit('invoice-created')
              attachToDelivery([existingInvoiceId])
              return
            }

            const msg = (err.response && err.response.data && err.response.data.message)
              ? err.response.data.message
              : this.$t('invoice.requestFailed')
            swal(this.$t('common.warning'), msg, 'error')
          })
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  overflow-y: auto !important;
  overflow-x: hidden;
}

.orange-text .v-input__slot {
  color: #ce7706 !important;
}
.orange-text input {
  color: #ce7706 !important;
}
.orange-text label {
  color: #ce7706 !important;
}

.invoice-payment-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 4px;
}

.partial-remaining-note {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 600;
  color: #6B4C00;
}

.available-balance-box {
  border: 1px solid #3f51b5;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 8px;
  background: rgba(63, 81, 181, 0.06);
}
.available-balance-box ul {
  margin: 4px 0;
  padding-left: 18px;
}
.available-balance-box .balance-hint {
  font-size: 12px;
  color: #3f51b5;
}
.balance-history-box {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 13px;
  height: 100%;
}

.balance-equation {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 10px;
}

.balance-equation-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.balance-equation-label {
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.balance-equation-op {
  font-size: 16px;
  font-weight: bold;
  color: #666;
}

.balance-positive {
  color: #1A5940;
  font-weight: 600;
}

.balance-negative {
  color: #F63049;
  font-weight: 600;
}

.balance-extra-line {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 6px;
}

.balance-extra-line--column {
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.out-office-note {
  color: #6B4C00;
  font-weight: 600;
}

.selected-invoice-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.selected-invoice-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.out-office-badge {
  background: #FFE0B2;
  color: #6B4C00;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/AddOrderInvoice.vue